// import React, { useState, useEffect, useContext, useMemo } from "react";
// import {
//   Box,
//   Grid,
//   TextField,
//   MenuItem,
//   Autocomplete,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import Card from "@mui/material/Card";
// import { useSelector, useDispatch } from "react-redux";
// import MDButton from "components/MDButton";
// import MDSnackbar from "components/MDSnackbar";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import MDBox from "components/MDBox";
// import axios from "axios";
// import { updateaccount, removeaccount } from "config";
// import { createFilterOptions } from "@mui/material/Autocomplete";
// import { useNavigate } from "react-router-dom";
// import { AccountsContext } from "context/AccountsContext";
// import { setSelectedStudent } from "features/StudentData/studentSlice";

// export default function AccountDetailsForm() {
//   const { handleAccount, accounts, loading: accountsLoading } = useContext(AccountsContext);
//   const dispatch = useDispatch();
//   const selectedStudent = useSelector((state) => state.student.selectedStudent);
//   const navigate = useNavigate();

//   // Load the full accounts list once, so the Account Id dropdown has data
//   // to show as soon as the field is clicked.
//   useEffect(() => {
//     handleAccount();
//   }, []);

//   // Build the dropdown options from context accounts.
//   const accountOptions = useMemo(() => {
//     return Object.values(accounts || {})
//       .map((item) => item.account)
//       .filter(Boolean);
//   }, [accounts]);

//   const isEditMode = !!selectedStudent;

//   const [formData, setFormData] = useState({
//     accountId: "",
//     name: "",
//     rollNumber: "",
//     standard: "",
//     guardianNumbers: [],
//     rfidTag: "",
//     address: "",
//     role: "STUDENT",
//   });

//   // Split the combined "name" field back into first/last for the API
//   // payload. First word = firstName, remaining words = lastName.
//   const splitName = (fullName) => {
//     const parts = (fullName || "").trim().split(/\s+/).filter(Boolean);
//     const firstName = parts.shift() || "";
//     const lastName = parts.join(" ");
//     return { firstName, lastName };
//   };

//   useEffect(() => {
//     if (selectedStudent) {
//       setFormData({
//         accountId: selectedStudent.account?.accountId || "",
//         name: [selectedStudent.account?.firstName, selectedStudent.account?.lastName]
//           .filter(Boolean)
//           .join(" "),
//         rollNumber: selectedStudent.account?.extra?.rollNumber || "",
//         standard: selectedStudent.account?.extra?.standard || "",
//         guardianNumbers: selectedStudent.account?.extra?.guardians || [],
//         rfidTag: selectedStudent.account?.extra?.rfidTag || "",
//         address: selectedStudent.account?.address || "",
//         role: selectedStudent.account?.role || "STUDENT",
//       });
//     }
//   }, [selectedStudent]);

//   const [successSB, setSuccessSB] = useState(false);
//   const [errorSB, setErrorSB] = useState(false);

//   const openSuccessSB = () => setSuccessSB(true);
//   const closeSuccessSB = () => setSuccessSB(false);
//   const openErrorSB = () => setErrorSB(true);
//   const closeErrorSB = () => setErrorSB(false);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };
//   const [newGuardian, setNewGuardian] = useState("");

//   // guardian add
//   const handleAddGuardian = () => {
//     if (newGuardian.trim() !== "" && /^\d{10}$/.test(newGuardian)) {
//       // only 10 digit number
//       setFormData({
//         ...formData,
//         guardianNumbers: [...formData.guardianNumbers, "91" + newGuardian], // add 91 prefix
//       });
//       setNewGuardian("");
//     }
//   };

//   // guardian remove
//   const handleRemoveGuardian = (index) => {
//     const updated = [...formData.guardianNumbers];
//     updated.splice(index, 1);
//     setFormData({ ...formData, guardianNumbers: updated });
//   };

//   const handleClear = () => {
//     setFormData({
//       accountId: "",
//       name: "",
//       rollNumber: "",
//       standard: "",
//       guardianNumbers: [],
//       rfidTag: "",
//       address: "",
//       role: "STUDENT",
//     });
//     dispatch(setSelectedStudent(null));
//   };

//   const handleUploadExcel = () => {
//     console.log("Upload Excel clicked");
//     navigate("/bulk-student-upload");
//     openSuccessSB();
//   };

//   const handleSubmit = async () => {
//     try {
//       const { firstName, lastName } = splitName(formData.name);

//       const payload = {
//         accounts: [
//           {
//             accountId: isEditMode
//               ? formData.accountId?.split("::")[1]
//               : formData.accountId,

//             firstName,
//             lastName,
//             role: formData.role,
//             address: formData.address,
//             rfidTag: formData.rfidTag || null,
//             extra: {
//               standard: formData.standard,
//               rollNumber: formData.rollNumber,
//               guardians: formData.guardianNumbers || [],
//             },
//           },
//         ],
//       };
//       console.log(payload);
//       const token = localStorage.getItem("token");

//       const config = {
//         method: "post",
//         maxBodyLength: Infinity,
//         url: updateaccount,
//         headers: {
//           "x-dhundhoo-session": token,
//           "Content-Type": "application/json",
//         },
//         data: JSON.stringify(payload),
//       };

//       const response = await axios.request(config);
//       console.log("✅ API Response:", response.data);
//       handleAccount();
//       // setFormData({
//       //   accountId: "",
//       //   name: "",
//       //   rollNumber: "",
//       //   standard: "",
//       //   guardianNumbers: [],
//       //   rfidTag: "",
//       //   address: "",
//       //   role: "STUDENT",
//       // });
//       dispatch(setSelectedStudent(null));
//       openSuccessSB();
//     } catch (error) {
//       console.error("❌ API Error:", error);
//       openErrorSB();
//     }
//   };

//   const handleRemove = async (accountId) => {
//     try {
//       const payload = [accountId];
//       const token = localStorage.getItem("token");
//       const config = {
//         method: "post",
//         url: removeaccount,
//         headers: {
//           "x-dhundhoo-session": token,
//           "Content-Type": "application/json",
//         },
//         data: JSON.stringify(payload),
//         maxBodyLength: Infinity,
//       };

//       const response = await axios.request(config);
//       console.log("✅ Remove Response:", response.data);
//       handleAccount();
//       setFormData({
//         accountId: "",
//         name: "",
//         rollNumber: "",
//         standard: "",
//         guardianNumbers: [],
//         rfidTag: "",
//         address: "",
//         role: "STUDENT",
//       });
//       dispatch(setSelectedStudent(null));
//       openSuccessSB();
//     } catch (error) {
//       console.error("❌ Remove API Error:", error);
//       openErrorSB();
//     }
//   };

//   const getTextFieldHeight = () => {
//     if (isMobile) return "48px";
//     if (isTablet) return "52px";
//     return "56px";
//   };

//   const getButtonStyles = () => ({
//     fontSize: isMobile ? "0.75rem" : isTablet ? "0.875rem" : "1rem",
//     padding: isMobile ? "5px 10px" : isTablet ? "7px 14px" : "9px 18px",
//     minWidth: isMobile ? "100px" : isTablet ? "120px" : "140px",
//   });

//   const getCardPadding = () => {
//     if (isMobile) return 2;
//     if (isTablet) return 3;
//     return 4;
//   };

//   const getMDBoxPadding = () => {
//     if (isMobile) return 3;
//     if (isTablet) return 4;
//     return 5;
//   };

//   // Snackbars
//   const renderSuccessSB = (
//     <MDSnackbar
//       color="success"
//       icon="check"
//       title="Account Action"
//       content={isEditMode ? "Account updated successfully!" : "Account added successfully!"}
//       dateTime="Just now"
//       open={successSB}
//       onClose={closeSuccessSB}
//       close={closeSuccessSB}
//       bgWhite
//     />
//   );

//   const renderErrorSB = (
//     <MDSnackbar
//       color="error"
//       icon="warning"
//       title="Account Action"
//       content={isEditMode ? "Failed to update account. Please try again." : "Failed to add account. Please try again."}
//       dateTime="Just now"
//       open={errorSB}
//       onClose={closeErrorSB}
//       close={closeErrorSB}
//       bgWhite
//     />
//   );

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <MDBox pt={6} pb={3}>
//         <Grid container spacing={6}>
//           <Grid item xs={12}>
//             <Card sx={{ maxWidth: 900, mx: "auto", p: getCardPadding() }}>
//               {/* Top Right Action Button */}
//               <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
//                 <MDButton
//                   variant="gradient"
//                   color="warning"
//                   onClick={handleUploadExcel}
//                   sx={getButtonStyles()}
//                 >
//                   Upload Excel
//                 </MDButton>
//               </Box>

//               {/* Form */}
//               <MDBox pt={getMDBoxPadding()} px={getMDBoxPadding()} pb={getMDBoxPadding()}>
//                 <Grid container spacing={2}>

//                   {/* Account Id - now a searchable dropdown of all accounts,
//                       but still typeable to create a new one */}
//                   <Grid item xs={12}>
//                     <Autocomplete
//                       freeSolo
//                       options={accountOptions}
//                       loading={accountsLoading}
//                       getOptionLabel={(option) =>
//                         typeof option === "string" ? option : option.accountId || ""
//                       }
//                       filterOptions={(options, state) => {
//                         const input = state.inputValue.toLowerCase().trim();
//                         if (!input) return options;

//                         return options.filter((option) => {
//                           const accountId = (option.accountId || "").toLowerCase();
//                           const firstName = (option.firstName || "").toLowerCase();
//                           const lastName = (option.lastName || "").toLowerCase();
//                           const fullName = `${firstName} ${lastName}`.trim();

//                           return (
//                             accountId.includes(input) ||
//                             firstName.includes(input) ||
//                             lastName.includes(input) ||
//                             fullName.includes(input)
//                           );
//                         });
//                       }}
//                       isOptionEqualToValue={(option, value) => {
//                         const valId = typeof value === "string" ? value : value?.accountId;
//                         return option.accountId === valId;
//                       }}
//                       inputValue={formData.accountId}
//                       onInputChange={(event, newInputValue, reason) => {
//                         // keep manual typing working (new account id / create mode)
//                         if (reason === "input") {
//                           if (selectedStudent) dispatch(setSelectedStudent(null));
//                           // Reset every other field so nothing from a
//                           // previously selected account (e.g. rollNumber)
//                           // leaks into a fresh, not-yet-saved account.
//                           setFormData({
//                             accountId: newInputValue,
//                             name: "",
//                             rollNumber: "",
//                             standard: "",
//                             guardianNumbers: [],
//                             rfidTag: "",
//                             address: "",
//                             role: "STUDENT",
//                           });
//                         }
//                       }}
//                       onChange={(event, newValue) => {
//                         if (newValue && typeof newValue === "object") {
//                           // selected an existing account from the dropdown
//                           dispatch(setSelectedStudent({ account: newValue }));
//                         } else if (typeof newValue === "string") {
//                           dispatch(setSelectedStudent(null));
//                           setFormData({
//                             accountId: newValue,
//                             name: "",
//                             rollNumber: "",
//                             standard: "",
//                             guardianNumbers: [],
//                             rfidTag: "",
//                             address: "",
//                             role: "STUDENT",
//                           });
//                         } else {
//                           dispatch(setSelectedStudent(null));
//                         }
//                       }}
//                       renderOption={(props, option) => (
//                         <li
//                           {...props}
//                           key={option.accountId}
//                           style={{ display: "flex", justifyContent: "space-between", width: "100%" }}
//                         >
//                           <span>
//                             {[option.firstName, option.lastName].filter(Boolean).join(" ")}
//                           </span>
//                           <span style={{ color: "gray", fontSize: "0.85rem" }}>
//                             {option.accountId?.includes("::")
//                               ? option.accountId.split("::")[1]
//                               : option.accountId}
//                           </span>
//                         </li>
//                       )}
//                       renderInput={(params) => (
//                         <TextField
//                           {...params}
//                           fullWidth
//                           label="Account Id"
//                           placeholder="Select an existing Account Id or type a new one"
//                           required
//                         />
//                       )}
//                     />
//                   </Grid>

//                   {/* Name (combined first + last) */}
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       label="Name"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleChange}
//                     />
//                   </Grid>

//                   {/* Roll Number + Standard */}
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="Roll Number"
//                       name="rollNumber"
//                       value={formData.rollNumber}
//                       onChange={handleChange}
//                     />
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="Standard"
//                       name="standard"
//                       value={formData.standard}
//                       onChange={handleChange}
//                     />
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" gap={2} mb={2}>
//                       <TextField
//                         fullWidth
//                         label="Guardian Number"
//                         value={newGuardian}
//                         onChange={(e) => setNewGuardian(e.target.value)}
//                         placeholder="Enter 10 digit number"
//                       />
//                       <MDButton variant="gradient" color="warning" onClick={handleAddGuardian}>
//                         Add
//                       </MDButton>
//                     </Box>

//                     {/* Show added guardians */}
//                     <Box display="flex" flexWrap="wrap" gap={1}>
//                       {formData.guardianNumbers.map((num, idx) => (
//                         <Box
//                           key={idx}
//                           sx={{
//                             display: "flex",
//                             alignItems: "center",
//                             background: "#f0f0f0",
//                             borderRadius: "20px",
//                             padding: "3px 6px",
//                           }}
//                         >
//                           <span>{num}</span>
//                           <MDButton
//                             onClick={() => handleRemoveGuardian(idx)}
//                             sx={{ ml: 1, minWidth: "10px", padding: "2px 4px" }}
//                             color="error"
//                           >
//                             X
//                           </MDButton>
//                         </Box>
//                       ))}
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       label="RFID Tag"
//                       name="rfidTag"
//                       value={formData.rfidTag}
//                       onChange={handleChange}
//                     />
//                   </Grid>

//                   {/* Address */}
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       label="Address"
//                       name="address"
//                       value={formData.address}
//                       onChange={handleChange}
//                     />
//                   </Grid>

//                   {/* Role */}
//                   <Grid item xs={12}>
//                     <TextField
//                       select
//                       fullWidth
//                       label="Role"
//                       name="role"
//                       value={formData.role}
//                       onChange={handleChange}
//                       sx={{
//                         "& .MuiInputBase-root": { height: getTextFieldHeight() },
//                         "& .MuiInputBase-input": {
//                           padding: isMobile
//                             ? "12px 14px"
//                             : isTablet
//                               ? "14px 14px"
//                               : "16px 14px",
//                         },
//                         "& .MuiMenuItem-root": {
//                           fontSize: isMobile ? "0.9rem" : "1rem",
//                           padding: isMobile ? "8px 16px" : "12px 16px",
//                         },
//                       }}
//                     >
//                       <MenuItem value="STUDENT">STUDENT</MenuItem>
//                       <MenuItem value="STAFF">STAFF</MenuItem>
//                       <MenuItem value="DRIVER">DRIVER</MenuItem>
//                       <MenuItem value="ATTENDENT">ATTENDENT</MenuItem>
//                     </TextField>
//                   </Grid>
//                 </Grid>

//                 {/* Buttons */}
//                 <Grid
//                   item
//                   xs={12}
//                   sx={{
//                     display: "flex",
//                     flexDirection: isMobile ? "column" : "row",
//                     gap: 2,
//                     mt: 3,
//                   }}
//                 >
//                   <MDButton
//                     variant="gradient"
//                     color="warning"
//                     onClick={handleSubmit}
//                     sx={getButtonStyles()}
//                   >
//                     {isEditMode ? "Update Account" : "Add Account"}
//                   </MDButton>
//                   <MDButton
//                     variant="gradient"
//                     color="warning"
//                     onClick={handleClear}
//                     sx={getButtonStyles()}
//                   >
//                     Clear
//                   </MDButton>
//                   {isEditMode && (
//                     <MDButton
//                       variant="gradient"
//                       color="error"
//                       onClick={() =>
//                         handleRemove(
//                           formData.accountId?.includes("::")
//                             ? formData.accountId
//                             : formData.accountId
//                         )
//                       }
//                       sx={getButtonStyles()}
//                     >
//                       Remove
//                     </MDButton>
//                   )}
//                 </Grid>
//               </MDBox>
//             </Card>
//           </Grid>
//         </Grid>
//       </MDBox>
//       {renderSuccessSB}
//       {renderErrorSB}
//     </DashboardLayout>
//   );
// }

import React, { useState, useEffect, useContext, useMemo } from "react";
import {
  Box,
  Grid,
  TextField,
  MenuItem,
  Autocomplete,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Card from "@mui/material/Card";
import { useSelector, useDispatch } from "react-redux";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import axios from "axios";
import { updateaccount, removeaccount } from "config";
import { useNavigate } from "react-router-dom";
import { AccountsContext } from "context/AccountsContext";
import { setSelectedStudent } from "features/StudentData/studentSlice";

const EMPTY_FORM = {
  accountId: "",
  name: "",
  rollNumber: "",
  standard: "",
  guardianNumbers: [],
  rfidTag: "",
  address: "",
  role: "STUDENT",
};

const getRfidTag = (account = {}) => {
  const extra = account.extra || {};
  const value =
    account.rfidTag ??
    account.rfidtag ??
    account.rfidNumber ??
    account.rfidnumber ??
    account.rfid ??
    account.accessId ??
    extra.rfidTag ??
    extra.rfidtag ??
    extra.rfidNumber ??
    extra.rfidnumber ??
    extra.rfid ??
    extra.accessId ??
    "";

  return value == null ? "" : String(value);
};

const normalizeId = (value) => String(value ?? "").trim().toLowerCase();

const getAdmissionNumber = (accountId) => {
  if (!accountId) return "";
  const parts = String(accountId).split("::");
  return parts.length > 1 ? parts[1] : String(accountId);
};

const mergeAccountDetails = (selectedAccount = {}, loadedAccount = {}) => ({
  ...selectedAccount,
  ...loadedAccount,
  extra: {
    ...(selectedAccount.extra || {}),
    ...(loadedAccount.extra || {}),
  },
});

export default function AccountDetailsForm() {
  const { handleAccount, accounts, loading: accountsLoading } = useContext(AccountsContext);
  const dispatch = useDispatch();
  const selectedStudent = useSelector((state) => state.student.selectedStudent);
  const navigate = useNavigate();

  // Load the full accounts list once, so the Account Id dropdown has data
  // to show as soon as the field is clicked.
  useEffect(() => {
    handleAccount();
  }, []);

  // Build the dropdown options from context accounts.
  const accountOptions = useMemo(() => {
    return Object.values(accounts || {})
      .map((item) => {
        const account = item.account;
        if (!account) return null;

        const wrapperRfidTag = getRfidTag(item);
        return wrapperRfidTag && !getRfidTag(account)
          ? { ...account, rfidTag: wrapperRfidTag }
          : account;
      })
      .filter(Boolean);
  }, [accounts]);

  const isEditMode = !!selectedStudent;

  const [formData, setFormData] = useState(EMPTY_FORM);

  // Snackbar message is based on the last action performed, not on the
  // current isEditMode, because isEditMode can change right after submit.
  const [lastAction, setLastAction] = useState("add"); // "add" | "update" | "remove"

  // Split the combined "name" field back into first/last for the API
  // payload. First word = firstName, remaining words = lastName.
  const splitName = (fullName) => {
    const parts = (fullName || "").trim().split(/\s+/).filter(Boolean);
    const firstName = parts.shift() || "";
    const lastName = parts.join(" ");
    return { firstName, lastName };
  };

  useEffect(() => {
    if (selectedStudent) {
      const selectedAccount = selectedStudent.account || {};
      const selectedAccountId = selectedAccount.accountId;
      const selectedAdmissionNo = getAdmissionNumber(selectedAccountId);
      const loadedAccount = accountOptions.find((account) => {
        const loadedAccountId = account.accountId;
        const loadedAdmissionNo = getAdmissionNumber(loadedAccountId);

        return (
          normalizeId(loadedAccountId) === normalizeId(selectedAccountId) ||
          normalizeId(loadedAdmissionNo) === normalizeId(selectedAdmissionNo)
        );
      });
      const account = mergeAccountDetails(selectedAccount, loadedAccount);

      setFormData({
        accountId: account.accountId || "",
        name: [account.firstName, account.lastName]
          .filter(Boolean)
          .join(" "),
        rollNumber: account.extra?.rollNumber || "",
        standard: account.extra?.standard || "",
        guardianNumbers: account.extra?.guardians || [],
        rfidTag: getRfidTag(account) || getRfidTag(selectedStudent),
        address: account.address || "",
        role: account.role || "STUDENT",
      });
    }
  }, [selectedStudent, accountOptions]);

  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);

  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const [newGuardian, setNewGuardian] = useState("");

  // guardian add
  const handleAddGuardian = () => {
    if (newGuardian.trim() !== "" && /^\d{10}$/.test(newGuardian)) {
      // only 10 digit number
      setFormData({
        ...formData,
        guardianNumbers: [...formData.guardianNumbers, "91" + newGuardian], // add 91 prefix
      });
      setNewGuardian("");
    }
  };

  // guardian remove
  const handleRemoveGuardian = (index) => {
    const updated = [...formData.guardianNumbers];
    updated.splice(index, 1);
    setFormData({ ...formData, guardianNumbers: updated });
  };

  const handleClear = () => {
    setFormData(EMPTY_FORM);
    setNewGuardian("");
    dispatch(setSelectedStudent(null));
  };

  const handleUploadExcel = () => {
    navigate("/bulk-student-upload");
  };

  const handleSubmit = async () => {
    // Remember what we are doing *before* any state changes.
    const action = isEditMode ? "update" : "add";
    setLastAction(action);

    try {
      const { firstName, lastName } = splitName(formData.name);

      const payload = {
        accounts: [
          {
            accountId: isEditMode
              ? formData.accountId?.split("::")[1]
              : formData.accountId,

            firstName,
            lastName,
            role: formData.role,
            address: formData.address,
            rfidTag: formData.rfidTag || null,
            extra: {
              standard: formData.standard,
              rollNumber: formData.rollNumber,
              guardians: formData.guardianNumbers || [],
            },
          },
        ],
      };
      console.log(payload);
      const token = localStorage.getItem("token");

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: updateaccount,
        headers: {
          "x-dhundhoo-session": token,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
      };

      const response = await axios.request(config);
      console.log("✅ API Response:", response.data);
      handleAccount();

      if (action === "update") {
        // Stay in edit mode: keep the student selected, but refresh the
        // stored data with what was just saved.
        dispatch(
          setSelectedStudent({
            account: {
              ...selectedStudent.account,
              firstName,
              lastName,
              role: formData.role,
              address: formData.address,
              rfidTag: formData.rfidTag || null,
              rfidNumber: formData.rfidTag || null,
              extra: {
                ...selectedStudent.account?.extra,
                standard: formData.standard,
                rollNumber: formData.rollNumber,
                guardians: formData.guardianNumbers || [],
                rfidTag: formData.rfidTag || "",
                rfidNumber: formData.rfidTag || "",
              },
            },
          })
        );
      } else {
        // New account was added: reset the form for the next entry.
        handleClear();
      }

      openSuccessSB();
    } catch (error) {
      console.error("❌ API Error:", error);
      openErrorSB();
    }
  };

  const handleRemove = async (accountId) => {
    setLastAction("remove");
    try {
      const payload = [accountId];
      const token = localStorage.getItem("token");
      const config = {
        method: "post",
        url: removeaccount,
        headers: {
          "x-dhundhoo-session": token,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
        maxBodyLength: Infinity,
      };

      const response = await axios.request(config);
      console.log("✅ Remove Response:", response.data);
      handleAccount();
      handleClear();
      openSuccessSB();
    } catch (error) {
      console.error("❌ Remove API Error:", error);
      openErrorSB();
    }
  };

  const getTextFieldHeight = () => {
    if (isMobile) return "48px";
    if (isTablet) return "52px";
    return "56px";
  };

  const getButtonStyles = () => ({
    fontSize: isMobile ? "0.75rem" : isTablet ? "0.875rem" : "1rem",
    padding: isMobile ? "5px 10px" : isTablet ? "7px 14px" : "9px 18px",
    minWidth: isMobile ? "100px" : isTablet ? "120px" : "140px",
  });

  const getCardPadding = () => {
    if (isMobile) return 2;
    if (isTablet) return 3;
    return 4;
  };

  const getMDBoxPadding = () => {
    if (isMobile) return 3;
    if (isTablet) return 4;
    return 5;
  };

  const successMessages = {
    add: "Account added successfully!",
    update: "Account updated successfully!",
    remove: "Account removed successfully!",
  };

  const errorMessages = {
    add: "Failed to add account. Please try again.",
    update: "Failed to update account. Please try again.",
    remove: "Failed to remove account. Please try again.",
  };

  // Snackbars
  const renderSuccessSB = (
    <MDSnackbar
      color="success"
      icon="check"
      title="Account Action"
      content={successMessages[lastAction]}
      dateTime="Just now"
      open={successSB}
      onClose={closeSuccessSB}
      close={closeSuccessSB}
      bgWhite
    />
  );

  const renderErrorSB = (
    <MDSnackbar
      color="error"
      icon="warning"
      title="Account Action"
      content={errorMessages[lastAction]}
      dateTime="Just now"
      open={errorSB}
      onClose={closeErrorSB}
      close={closeErrorSB}
      bgWhite
    />
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card sx={{ maxWidth: 900, mx: "auto", p: getCardPadding() }}>
              {/* Top Right Action Button */}
              <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                <MDButton
                  variant="gradient"
                  color="warning"
                  onClick={handleUploadExcel}
                  sx={getButtonStyles()}
                >
                  Upload Excel
                </MDButton>
              </Box>

              {/* Form */}
              <MDBox pt={getMDBoxPadding()} px={getMDBoxPadding()} pb={getMDBoxPadding()}>
                <Grid container spacing={2}>
                  {/* Account Id - searchable dropdown of all accounts,
                      but still typeable to create a new one */}
                  <Grid item xs={12}>
                    <Autocomplete
                      freeSolo
                      options={accountOptions}
                      loading={accountsLoading}
                      getOptionLabel={(option) =>
                        typeof option === "string" ? option : option.accountId || ""
                      }
                      filterOptions={(options, state) => {
                        const input = state.inputValue.toLowerCase().trim();
                        if (!input) return options;

                        return options.filter((option) => {
                          const accountId = (option.accountId || "").toLowerCase();
                          const firstName = (option.firstName || "").toLowerCase();
                          const lastName = (option.lastName || "").toLowerCase();
                          const fullName = `${firstName} ${lastName}`.trim();

                          return (
                            accountId.includes(input) ||
                            firstName.includes(input) ||
                            lastName.includes(input) ||
                            fullName.includes(input)
                          );
                        });
                      }}
                      isOptionEqualToValue={(option, value) => {
                        const valId = typeof value === "string" ? value : value?.accountId;
                        return option.accountId === valId;
                      }}
                      inputValue={formData.accountId}
                      onInputChange={(event, newInputValue, reason) => {
                        // keep manual typing working (new account id / create mode)
                        if (reason === "input") {
                          if (selectedStudent) dispatch(setSelectedStudent(null));
                          // Reset every other field so nothing from a
                          // previously selected account leaks into a fresh,
                          // not-yet-saved account.
                          setFormData({ ...EMPTY_FORM, accountId: newInputValue });
                        }
                      }}
                      onChange={(event, newValue) => {
                        if (newValue && typeof newValue === "object") {
                          // selected an existing account from the dropdown
                          dispatch(setSelectedStudent({ account: newValue }));
                        } else if (typeof newValue === "string") {
                          dispatch(setSelectedStudent(null));
                          setFormData({ ...EMPTY_FORM, accountId: newValue });
                        } else {
                          dispatch(setSelectedStudent(null));
                        }
                      }}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          key={option.accountId}
                          style={{ display: "flex", justifyContent: "space-between", width: "100%" }}
                        >
                          <span>
                            {[option.firstName, option.lastName].filter(Boolean).join(" ")}
                          </span>
                          <span style={{ color: "gray", fontSize: "0.85rem" }}>
                            {option.accountId?.includes("::")
                              ? option.accountId.split("::")[1]
                              : option.accountId}
                          </span>
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          label="Account Id"
                          placeholder="Select an existing Account Id or type a new one"
                          required
                        />
                      )}
                    />
                  </Grid>

                  {/* Name (combined first + last) */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </Grid>

                  {/* Roll Number + Standard */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Roll Number"
                      name="rollNumber"
                      value={formData.rollNumber}
                      onChange={handleChange}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Standard"
                      name="standard"
                      value={formData.standard}
                      onChange={handleChange}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Box display="flex" gap={2} mb={2}>
                      <TextField
                        fullWidth
                        label="Guardian Number"
                        value={newGuardian}
                        onChange={(e) => setNewGuardian(e.target.value)}
                        placeholder="Enter 10 digit number"
                      />
                      <MDButton variant="gradient" color="warning" onClick={handleAddGuardian}>
                        Add
                      </MDButton>
                    </Box>

                    {/* Show added guardians */}
                    <Box display="flex" flexWrap="wrap" gap={1}>
                      {formData.guardianNumbers.map((num, idx) => (
                        <Box
                          key={idx}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            background: "#f0f0f0",
                            borderRadius: "20px",
                            padding: "3px 6px",
                          }}
                        >
                          <span>{num}</span>
                          <MDButton
                            onClick={() => handleRemoveGuardian(idx)}
                            sx={{ ml: 1, minWidth: "10px", padding: "2px 4px" }}
                            color="error"
                          >
                            X
                          </MDButton>
                        </Box>
                      ))}
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="RFID Tag"
                      name="rfidTag"
                      value={formData.rfidTag}
                      onChange={handleChange}
                    />
                  </Grid>

                  {/* Address */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Address"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </Grid>

                  {/* Role */}
                  <Grid item xs={12}>
                    <TextField
                      select
                      fullWidth
                      label="Role"
                      name="role"
                      value={formData.role}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": { height: getTextFieldHeight() },
                        "& .MuiInputBase-input": {
                          padding: isMobile
                            ? "12px 14px"
                            : isTablet
                              ? "14px 14px"
                              : "16px 14px",
                        },
                        "& .MuiMenuItem-root": {
                          fontSize: isMobile ? "0.9rem" : "1rem",
                          padding: isMobile ? "8px 16px" : "12px 16px",
                        },
                      }}
                    >
                      <MenuItem value="STUDENT">STUDENT</MenuItem>
                      <MenuItem value="STAFF">STAFF</MenuItem>
                      <MenuItem value="DRIVER">DRIVER</MenuItem>
                      <MenuItem value="ATTENDENT">ATTENDENT</MenuItem>
                    </TextField>
                  </Grid>
                </Grid>

                {/* Buttons */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    gap: 2,
                    mt: 3,
                  }}
                >
                  <MDButton
                    variant="gradient"
                    color="warning"
                    onClick={handleSubmit}
                    sx={getButtonStyles()}
                  >
                    {isEditMode ? "Update Account" : "Add Account"}
                  </MDButton>
                  <MDButton
                    variant="gradient"
                    color="warning"
                    onClick={handleClear}
                    sx={getButtonStyles()}
                  >
                    Clear
                  </MDButton>
                  {isEditMode && (
                    <MDButton
                      variant="gradient"
                      color="error"
                      onClick={() => handleRemove(formData.accountId)}
                      sx={getButtonStyles()}
                    >
                      Remove
                    </MDButton>
                  )}
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {renderSuccessSB}
      {renderErrorSB}
    </DashboardLayout>
  );
}